import { useMemo } from 'react';

import { useCurrentPlatform } from 'src/lib/utils/hooks/useCurrentPlatform';

const useSwyftxSpot = () => {
  const { currentPlatform } = useCurrentPlatform();

  const isSwyftxSpot = useMemo(() => currentPlatform === 'swyftx' || !currentPlatform, [currentPlatform]);

  return {
    isSwyftxSpot,
  };
};

export { useSwyftxSpot };
